import { render, staticRenderFns } from "./goldMediator.vue?vue&type=template&id=64da82d3&scoped=true&"
import script from "./goldMediator.vue?vue&type=script&lang=js&"
export * from "./goldMediator.vue?vue&type=script&lang=js&"
import style0 from "./goldMediator.vue?vue&type=style&index=0&id=64da82d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da82d3",
  null
  
)

export default component.exports